export const GET_CAPACITY_SUCCESS = "GET_CAPACITY_SUCCESS";
export const GET_CAPACITY_FAILURE = "GET_CAPACITY_FAILURE";
export const FETCHING_CAPACITY = "FETCHING_CAPACITY";